import UpdateDetailsLayout from '../components/organisms/UpdateDetailsLayout';
import useUpdateDetails from '../hooks/updateDetails.hook';
import { useParams } from 'react-router-dom';
import { useState } from 'react';

const UpdateDetails = () => {
  const [loading, setLoading] = useState(false);
  const { hash } = useParams();
  const { data, detailsToUpdate, handleFormUpdate, formSubmit } =
    useUpdateDetails({
      hash,
      setLoading,
    });

  if (data?.student === false)
    return <div className='bold text-2xl'>Student not found</div>;
  else
    return (
      <div>
        <UpdateDetailsLayout
          studentData={data}
          detailsToUpdate={detailsToUpdate}
          handleFormUpdate={handleFormUpdate}
          formSubmit={formSubmit}
          loading={loading}
          setLoading={setLoading}
        />
      </div>
    );
};

export default UpdateDetails;
